import './App.css';

function App() {
  return (

    <div className="App">
     <center><h1>Poet's Life</h1></center>
     <br/>
      <table align="center" cellspacing="5" >
      <tr>
      <td align="justify">
      <b>आख़िरी हिम्मत (Aakhiri Himmat)</b><br/>
      - <a href="https://mr-ravin.github.io" target="__blank__">रविन कुमार</a>
      <p>
      ऐ मायूस इंसान, बस एक आख़िरी हिम्मत जुटा के देख,<br/>

      खुद की नज़रों में खुदी को, खुद का ख़ुदा बना के देख।<br/>

      तेरा समंदर तू, तेरा आस्माँ तू,<br/>

      तेरा दरिया तू, तेरा ज़रिया तू।<br/>

      कर इबादत तू खुद से खुदी की,<br/>

      होगी हासिल जो भी तेरी मंज़िल थी,<br/>

      मेहनत कर, और खुद को, खुद का ख़ुदा बना के देख।
      </p>
      &copy; 2025 रविन कुमार
      <br/><br/><br/>
      </td>
      </tr>
      <tr>
      <td align="justify">
      <b>बस इंसान (Bas Insaan)</b><br/>
      - <a href="https://mr-ravin.github.io" target="__blank__">रविन कुमार</a>
      <p>
      ज़ेहनी ज़ंजीरों से आज़ाद हो पाता,<br/>
      काश इंसान बस इंसान हो पाता।<br/>

      जन्नत और जहन्नुम के पार हो पाता,<br/>
      काश इंसान बस इंसान हो पाता।<br/>

      महफ़िल-ए-ज़िन्दगी में आबाद हो पाता,<br/>
      काश इंसान बस इंसान हो पाता।<br/>

      ढूँढे बिन उसे ख़ुदा, भगवान मिल पाता,<br/>
      काश इंसान बस इंसान हो पाता।
      </p>
      &copy; 2025 रविन कुमार
      <br/><br/><br/>
      </td>
      </tr>
      <tr>
      <td align="justify">
      <b>Not A Play</b><br/>
      by <a href="https://mr-ravin.github.io" target="__blank__">Ravin Kumar</a>
      <p>
      Being a being is not a play,<br/>
      to all the beings shall I say.<br/>
      Things we do merely matter,<br/>
      when compared to the world's setter.<br/>
      Don't just play the part O fellow being,<br/>
      when you can choose and can think.<br/>
      Being a being is not a play,<br/>
      for those who think and then say.
      </p>
      &copy; 2021 Ravin Kumar
      <br/><br/><br/>
      </td>
      </tr>
      <tr>
      <td align="justify">
      <b>To be</b><br/>
      by <a href="https://mr-ravin.github.io" target="__blank__">Ravin Kumar</a>
      <p>
      To be the spell caster,<br/>
      to be the new master.<br/>
      Don't do the work hard,<br/>
      do work that is harder.<br/>
      Skilled and smarter,<br/>
      says, crafter turned master.<br/>
      Don't do the work hard,<br/>
      do work that is harder.
      </p>
      &copy; 2021 Ravin Kumar
      <br/><br/><br/>
      </td>
      </tr>
      <tr>
      <td align="justify">
      <b>The devil's rule</b><br/>
      by <a href="https://mr-ravin.github.io" target="__blank__">Ravin Kumar</a>
      <p>
      Honest ones are call fool,<br/>
      Often happens when the devil rule.<br/>
      Unemployment and, people cry,<br/>
      honest ones are thinking why.<br/>
      News speakers start spreading the lie,<br/>
      Even the Gods do then say goodbye.<br/>
      People waiting for the honest's rule,<br/>
      Often happens when the devil rule.
      </p>
      &copy; 2021 Ravin Kumar
      <br/><br/><br/>
      </td>
      </tr>
      <tr>
      <td align="justify">
      <b>A Journey</b><br/>
      by <a href="https://mr-ravin.github.io" target="__blank__">Ravin Kumar</a>
      <p>
      With every new sun,<br/>
      a journey does begin.<br/>
      Offers happiness or cry,<br/>
      Seems doesn't worth a try.<br/>
      With each sinking sun,<br/>
      a searching does begin.<br/>
      One looking for a bed,<br/>
      Becoming the dead.
      </p>
      &copy; 2021 Ravin Kumar
      <br/><br/><br/>
      </td></tr>
      </table>
    </div>

  );
}

export default App;
